export const compassNames = [
  'N',
  'NNE',
  'NE',
  'ENE',
  'E',
  'ESE',
  'SE',
  'SSE',
  'S',
  'SSW',
  'SW',
  'WSW',
  'W',
  'WNW',
  'NW',
  'NNW',
];

/** Readings slower than this are calm: their direction is noise. */
export const CALM_SPEED = 0.5;

export const MS_TO_KNOTS = 1.94384;

export const compassIndex = (deg: number) => ((Math.round(deg / 22.5) % 16) + 16) % 16;

export const compassName = (deg: number) => compassNames[compassIndex(deg)];

export interface WindRoseData {
  counts: number[];
  calm: number;
  total: number;
  windy: number;
  prevailing?: { name: string; pct: number };
}

export const windRose = (samples: Array<{ speed?: number; direction?: number }>): WindRoseData => {
  const counts = new Array(16).fill(0);
  let calm = 0;
  let total = 0;
  samples.forEach(({ speed, direction }) => {
    if (speed === undefined) return;
    total++;
    if (speed < CALM_SPEED) {
      calm++;
      return;
    }
    if (direction === undefined) return;
    counts[compassIndex(direction)]++;
  });
  const windy = counts.reduce((a, b) => a + b, 0);
  const max = Math.max(...counts);
  const prevailing =
    max > 0 ? { name: compassNames[counts.indexOf(max)], pct: Math.round((100 * max) / windy) } : undefined;
  return { counts, calm, total, windy, prevailing };
};
